import { render, staticRenderFns } from "./PriceSurchargeModal.vue?vue&type=template&id=1361a1ac&scoped=true&"
import script from "./PriceSurchargeModal.vue?vue&type=script&lang=ts&"
export * from "./PriceSurchargeModal.vue?vue&type=script&lang=ts&"
import style0 from "./PriceSurchargeModal.vue?vue&type=style&index=0&id=1361a1ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1361a1ac",
  null
  
)

export default component.exports